import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import {  NavLink } from 'react-router-dom';
import styles from './Style.module.scss';
import { localizedStrings } from 'src/localization';
import Text from 'src/components/text';

class NDATemplateView extends React.Component {
  constructor(props) {
    super(props);

    this._handleDelete = this._handleDelete.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedNda = this.localizedSettings.templates.nda;
  }

  _handleDelete() {
    this.props.onDelete(this.props.value);
  }

  render() {
    const create = this.props.value == null;
    var url = `/settings/nda-templates/new`;
    
    if(!create){
      url = `/settings/nda-templates/${this.props.value.id}`;
    }

    return (
      <NavLink to={url} 
      className={({ isActive }) => cx(styles.item, { [styles.selected]: isActive })} >
      <Row>

        <Col xl={10} lg={10} md={10} className={styles.name}>
          <Text text={create ? this.localizedSettings.templates.email.untitled : this.props.value.name} lines={1} tooltip={{placement:"bottom"}} />
          {this.props.value && this.props.value.createdBy &&
            <div className={styles.owner}>{this.localizedCommons.owner} <span>{this.props.value.createdBy.firstName+ " " +this.props.value.createdBy.lastName}</span></div>
          }
        </Col>

        {!create &&
          <Col xl={2} lg={2} md={2} className={styles.actions}>
            <OverlayTrigger placement="top" overlay={
              <Tooltip id="addMenuTooltip">{this.localizedNda.delete_tooltip}</Tooltip>
            }>
              <div className={styles.action} onClick={this._handleDelete}>
                <i className="paperflite-delete"></i>
              </div>
            </OverlayTrigger>
          </Col>
        }
      </Row>
      </NavLink>
    );
  }
}

NDATemplateView.contextTypes = {
  selection: PropTypes.object
};

export default NDATemplateView;